import { useQuery } from "@tanstack/react-query";
import { api } from "shared/api";

const getStandardProductBumbalBeforeDays = async (
  order_id: string,
  orderDeliveryType: string,
) => {
  const res = await api().gersGetStandardProductBumbalBeforeDays(
    order_id,
    orderDeliveryType,
  );
  return res.data;
};

export const useGetBumbalBeforeDays = (
  order_id: string,
  orderDeliveryType: string,
) => {
  const {
    isLoading,
    isError,
    data: bumbalBeforeDays,
  } = useQuery({
    queryKey: ["use-get-bumbal-before-days", order_id, orderDeliveryType],
    queryFn: () =>
      getStandardProductBumbalBeforeDays(order_id, orderDeliveryType),
    enabled: !!order_id,
  });

  return { bumbalBeforeDays, isError, isLoading };
};
